import React from "react";
import { FileSpreadsheet, KanbanSquare, Link2, Upload, Users } from "lucide-react";

const CrmOnboardingPanel = ({ onNewLead, onImport, onOpenSettings }) => {
  return (
    <div className="crm-onboarding">
      <h3>Welcome to your CRM</h3>
      <p className="crm-insights__muted">
        Get started in a few steps — import leads, connect ads, or add your first enquiry.
      </p>
      <div className="crm-onboarding__grid">
        <button type="button" className="crm-onboarding__card" onClick={onNewLead}>
          <Users size={20} />
          <strong>Add first lead</strong>
          <span>Create a manual or voice enquiry</span>
        </button>
        <button type="button" className="crm-onboarding__card" onClick={onImport}>
          <Upload size={20} />
          <strong>Import Excel</strong>
          <span>Bulk upload from spreadsheet</span>
        </button>
        <button type="button" className="crm-onboarding__card" onClick={onOpenSettings}>
          <KanbanSquare size={20} />
          <strong>Set pipeline</strong>
          <span>Configure stages & automations</span>
        </button>
        <a href="/crm-analytics" className="crm-onboarding__card crm-onboarding__card--link">
          <Link2 size={20} />
          <strong>Connect integrations</strong>
          <span>Google Ads, Meta, webhooks</span>
        </a>
        <a href="/crm-analytics" className="crm-onboarding__card crm-onboarding__card--link">
          <FileSpreadsheet size={20} />
          <strong>View analytics</strong>
          <span>Conversion & pipeline reports</span>
        </a>
      </div>
    </div>
  );
};

export default CrmOnboardingPanel;
